import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { removeOthersFromWorkOrderChange } from '../WorkOrderChangeQueries';

export const useDeleteOthersFromWorkOrderChange = ({
    workOrderChangeId,
    checkedRowsArr,
    refreshTable,
    resetCheckedRows,
}: {
    workOrderChangeId: number;
    checkedRowsArr: any[];
    refreshTable: () => void;
    resetCheckedRows: () => void;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderChangeId,
            workOrderChangeOtherPriceIds: checkedRowsArr,
        }),
        [checkedRowsArr, workOrderChangeId],
    );

    const [
        deletePriceWorkOrderChangeData,
        deletePriceWorkOrderChangeStatus,
        deletePriceWorkOrderChangeErr,
        deletePriceWorkOrderChangeRequest,
        deletePriceWorkOrderChangeSetData,
    ] = useRequest({
        requestId: 'deleteOtherFromWorkOrderChange',
        query: removeOthersFromWorkOrderChange,
        withEffect: false,
    });

    const refreshData = useCallback(() => {
        refreshTable();
        resetCheckedRows();
    }, [refreshTable, resetCheckedRows]);

    const deleteOthersWorkOrderChangeHandler = useCallback(() => {
        dispatch(deletePriceWorkOrderChangeRequest(variables));
    }, [deletePriceWorkOrderChangeRequest, dispatch, variables]);

    return {
        deleteData: deletePriceWorkOrderChangeData?.uerRemoveWorkOrderChangeOtherCost,
        deleteStatus: deletePriceWorkOrderChangeStatus,
        deleteError: deletePriceWorkOrderChangeErr,
        deleteSetData: deletePriceWorkOrderChangeSetData,
        handleDelete: deleteOthersWorkOrderChangeHandler,
        onSuccess: refreshData,
    };
};
